<template>
  <o-view class="c-sales-view" :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio-inschrijving"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-section-header title="MOBIB-kaart">
        <template #right>
          <o-icon icon="info" @click.native="showOverlay('info')" />
        </template>
      </o-section-header>
      <o-section>
        <p>
          Voeg hier een foto toe van de voorzijde en achterzijde van je
          MOBIB-kaart.
        </p>
        <o-picture-uploader label="Voorkant" />
        <o-picture-uploader label="Achterkant" />
      </o-section>
      <o-overlay ref="info">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
          consectetur accumsan libero. Nullam quis elit at metus viverra tempor.
          Vivamus metus magna, dapibus at lacus et, tincidunt cursus tellus.
        </p>
      </o-overlay>
    </o-view>
    <o-pay-button label="Verder" to="/sales/car/cambio/onboarding/id" />
  </o-view>
</template>

<script>
import OFavoriteToggle from '@/components/OFavoriteToggle.vue'
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
import OPictureUploader from '@/components/OPictureUploader.vue'

export default {
  name: 'CambioMobibPicture',
  components: {
    OFavoriteToggle,
    OHeaderImage,
    OPayButton,
    OPictureUploader
  }
}
</script>
